module.exports = __webpack_public_path__ + "static/media/mockup-calendar-presentation.b2d9831a.png";